import React from 'react';
import styled from 'styled-components';
import { Tab, TabPanel, TabPanels, Tabs } from '@reach/tabs';
import '@reach/tabs/styles.css';
import { TabText } from '../../internal/internal-typography';
import { StyledTabList } from './tab_list';

const StyledTab = (props) => {
  const { isSelected, children, ...restProps } = props;
  return (
    <Tab {...restProps}>
      <TabText isSelected={isSelected}>{children}</TabText>
    </Tab>
  );
};

const StyledTabPanels = styled((props) => <TabPanels {...props} />)`
  padding: 1rem 0;
`;

export {
  Tabs,
  StyledTabList as TabList,
  StyledTab as Tab,
  StyledTabPanels as TabPanels,
  TabPanel,
};
